/**
 * ***************************
 * GlobalSubNav Routes in Discovery Tool *
 * ***************************
 */
import approvalDashboard from './approvalDashboard';
import overview from './overview';
import projects from './projects';

/**
 * ***************************
 * Discovery Tool Components *
 * ***************************
 */
const Discovery = () => import('@/components/Discovery/Discovery');

export default {
  parent: 'Discovery Tool',
  path: '/discovery',
  name: 'discoveryMain',
  meta: {
    /**
     * ! Make sure to order permissions same as children(having corresponding permission) order
     * Ex: Inside Childern "overview", permission defined is can_view_discovery_project
     * So we have placed can_view_discovery_project at 1st index in below permission array
     */
    permission: [
      { action: 'view', entity: 'discovery_project' },
      {
        action: 'view',
        entity: 'discovery_project_approval_dashboard'
      }
    ],
    redirectionMap: {
      can_view_discovery_project: '/discovery/overview',
      can_view_discovery_project_approval_dashboard:
        '/discovery/approval-dashboard'
    },
    validateSomePermissions: true,
    id: 'discovery-tool-tab'
  },
  component: Discovery,
  permission: [
    { action: 'view', entity: 'discovery_project' },
    {
      action: 'view',
      entity: 'discovery_project_approval_dashboard'
    }
  ],
  children: [overview, approvalDashboard, projects]
};
